/* eslint-disable react-hooks/exhaustive-deps */
// export default IncidentRequest;
import Loading from "components/Loading";
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import { FaBriefcase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FurtherInvestigation, Roles } from "types";
import { ITEMS_PER_PAGE } from "utils/constant";
import { DateView, errorHandler, hasRole } from "utils/helper";
// import PageHeader from "../../../components/PageHeader";
import PageHeader from "components/PageHeader";
import {
  fetchFurtherInvestigation,
  fetchFurtherInvestigationByAdminUnitAndRole,
} from "services/prosecutorPoliceService";
// import { fetchCrimeReferences } from "../../../services/incidentService";

const FurtherInvestigationListForPolice: React.FC = () => {
  const { showTooltip } = useTooltip();
  const { loginData } = useAuth();
  const [activeTab, setActiveTab] = useState("All");
  const [incidents, setIncidents] = useState<FurtherInvestigation[]>([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");

  const isZonalVariousChildClerk = hasRole(loginData?.roles, [
    Roles.zonalVariousChildWomenClerk,
  ]);
  const isZonalEconomicCorruptionClerk = hasRole(loginData?.roles, [
    Roles.zonalEconomicCoruptionClerk,
  ]);

  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const api =
      isZonalVariousChildClerk || isZonalEconomicCorruptionClerk
        ? fetchFurtherInvestigationByAdminUnitAndRole(
            loginData?.admin_unit_id,
            isZonalVariousChildClerk
              ? Roles.zonalVariousChildWomenClerk
              : Roles.zonalEconomicCoruptionClerk,
          )
        : fetchFurtherInvestigation();

    api
      .then((data) => {
        setIncidents(data);
        setLoading(false);
      })
      .catch((error) => {
        showTooltip(errorHandler(error));
        setLoading(false);
      });
  }, []);

  const searchTerm = search.trim().toLowerCase();

  const filteredIncidents = incidents.filter((incident) => {
    // 1️⃣ — existing text‑search fields
    const letter_number_received =
      incident.letter_number_received?.toString()?.toLowerCase() || "";
    const crime_registration_number =
      incident.crime_registration_number?.toString()?.toLowerCase() || "";
    const date_received = incident.date_sent_to_police
      ? new Date(incident.date_sent_to_police)
          .toLocaleDateString()
          .toLowerCase()
      : "";
    const Incident_Registration_number =
      incident.incident_registration_number?.toLowerCase() || "";

    const matchesText =
      letter_number_received.includes(searchTerm) ||
      crime_registration_number.includes(searchTerm) ||
      date_received.includes(searchTerm) ||
      Incident_Registration_number.includes(searchTerm);

    return matchesText;
  });

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate paginated incidents
  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const paginatedIncidents = filteredIncidents.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredIncidents.length / ITEMS_PER_PAGE);

  const isProsecutor = hasRole(loginData?.roles, [Roles.prosecutor]);

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <PageHeader
        title="Incident Request"
        icon={FaBriefcase}
        tabs={[]}
        activeTab={activeTab}
        onTabClick={setActiveTab}
        rightContent={
          <>
            {/* <input
              type="date"
              className="px-3 py-2 text-sm text-gray-600 border rounded"
              placeholder="Filter by Date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            /> */}
            {isProsecutor && (
              <button
                onClick={() => navigate("/incident-register")}
                className="px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
              >
                Register Incident
              </button>
            )}
          </>
        }
      />
      {/* {activeTab === "All" ? (
        <AllTab incidents={filteredIncidents} />
      ) : activeTab === "Approved" ? (
        <ApprovedTab />
      ) : activeTab === "Cancelled" ? (
        <CancelledTab />
      ) : null} */}

      <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
        <div className="overflow-hidden bg-white shadow rounded-xl">
          {loading ? (
            <Loading label="Loading Incidents" />
          ) : (
            <table className="w-full text-sm border-collapse">
              <thead className="text-white bg-black">
                <tr>
                  <th colSpan={7} className="p-4" rounded-t-lg>
                    <div className="flex items-center justify-between">
                      {/* Left: Back + Title */}
                      <div className="flex items-center gap-2 text-lg font-semibold">
                        <button
                          onClick={() => navigate(-1)}
                          className="text-white hover:text-gray-300"
                          title="Go Back"
                        >
                          ◀️
                        </button>
                        <span>Incidents List Table</span>
                      </div>

                      {/* Right: Search Box */}
                      <div className="relative w-80">
                        <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                          🔍
                        </span>
                        <input
                          type="text"
                          value={search}
                          onChange={(e) => setSearch(e.target.value)}
                          placeholder="Search"
                          className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                        />
                      </div>
                    </div>
                  </th>
                </tr>
                <tr>
                  {/* <th className="p-3 text-left">Reporter</th> */}
                  <th className="p-3 text-left">Crime Reg Num.</th>
                  <th className="p-3 text-left">Incident Reg No</th>
                  <th className="p-3 text-left">Date</th>
                  {/*date_sent_to_police */}
                  <th className="p-3 text-left">Letter Number Received</th>
                  <th className="p-3 text-left" rounded-tr-lg>
                    Detail
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedIncidents.map((investigation, idx) => (
                  <tr
                    key={idx + indexOfFirstItem}
                    className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                  >
                    {/* <td className="p-3">
                    <div className="flex items-center gap-1">
                      <img
                        src={incident?.requestedBy?.img || defaultAvatar}
                        alt="avatar"
                        className="w-[56] h-[56] rounded-full"
                      />
                      <div className="relative top-5 right-5">
                        {incident?.requestedBy ? sealCheck : null}
                      </div>
                      <div
                      className={
                        incident?.requestedBy?.isApproved ? "pl-0" : "pl-6"
                      }
                      >
                        <div className="font-base font-[Poppins]">
                          {incident?.requestedBy?.name}
                        </div>
                        <div className="font-xs text-xs font-[Poppins]">
                          {incident?.requestedBy?.role}
                        </div>
                      </div>
                    </div>
                  </td> */}
                    <td className="p-3 font-[500] font-[Poppins]">
                      {investigation?.crime_registration_number}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {investigation?.incident_registration_number}
                    </td>
                    <td className="p-3 font-[500] font-[inter]">
                      {DateView(investigation.date_sent_to_police)}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      {investigation?.letter_number_received}
                    </td>
                    <td className="p-3 font-[500] font-[Poppins]">
                      <button
                        type="button"
                        onClick={() =>
                          navigate(
                            "/further-investigation/" + investigation?.id,
                          )
                        }
                        className="px-4 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
                {filteredIncidents.length === 0 && (
                  <tr>
                    <td colSpan={6} className="p-4 text-center text-gray-500">
                      No incidents found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center gap-2 mt-4">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              Prev
            </button>
            <span className="px-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default FurtherInvestigationListForPolice;
